import { NavigateFunction } from "react-router-dom";
import { removeCookie } from "typescript-cookie";
import { create } from "zustand";
import { CurrentActiveUserInterface } from "../constants/User";
import {
  axiosBuyer,
  axiosReseller,
  axiosSupplier,
} from "../utils/AxiosInstance";
import { getAxiosInstance } from "../utils/helperFunction";
import { useGetUserLoginStore } from "./useGetUserLoginStore";
import { useUserHeader } from "./useUserHeader";

interface LogoutInterface {
  logoutUser: (toast: any, navigate: NavigateFunction) => void;
  logoutAll: (toast: any) => void;
  isLogoutLoading: boolean;
}

export const useLogoutStore = create<LogoutInterface>((set) => ({
  isLogoutLoading: false,
  logoutAll: async (toast: any) => {
    const storeGetUserLogin = useGetUserLoginStore.getState();
    storeGetUserLogin.getCurrentActiveUser();

    const logout = async () => {
      try {
        const urlBuyer = `/v1/buyer/logout`;
        const urlReseller = `/v1/reseller/logout`;
        const urlSupplier = `/v1/supplier/logout`;

        await axiosBuyer.post(
          `${process.env.REACT_APP_WEB_API_BASE_URL}${urlBuyer}`
        );

        await axiosReseller.post(
          `${process.env.REACT_APP_WEB_API_BASE_URL}${urlReseller}`
        );

        const responseSupplier = await axiosSupplier.post(
          `${process.env.REACT_APP_WEB_API_BASE_URL}${urlSupplier}`
        );

        removeCookie(`buyerToken`);
        removeCookie(`resellerToken`);
        removeCookie(`supplierToken`);
        removeCookie("currentActiveUser");
        removeCookie("loggedUsers");

        return responseSupplier;
      } catch (error: any) {
        toast({
          description: error?.response?.data?.message || "",
        });

        removeCookie(`buyerToken`);
        removeCookie(`resellerToken`);
        removeCookie(`supplierToken`);
        removeCookie("currentActiveUser");
        removeCookie("loggedUsers");

        window.location.href = `${process.env.REACT_APP_FRONTEND_URL}`;
      }
    };
    try {
      await logout();
      window.location.href = `${process.env.REACT_APP_FRONTEND_URL}`;
    } catch (error: any) {
      toast({
        description: error?.response?.data?.message || "",
      });
    } finally {
      set({ isLogoutLoading: false });
    }
  },
  logoutUser: async (toast: any, navigate: NavigateFunction) => {
    const storeGetUserLogin = useGetUserLoginStore.getState();
    storeGetUserLogin.getCurrentActiveUser();

    const saveLoggedUsers = storeGetUserLogin.saveLoggedUsers;

    const currentActiveUser = storeGetUserLogin.currentActiveUser;
    storeGetUserLogin.getLoggedUsers();

    const loggedUsers = storeGetUserLogin.loggedUsers;

    let response: any;

    const logoutUser = async (pageType: number) => {
      try {
        let userType: string = "buyer";

        if (pageType === 2) {
          userType = "reseller";
        } else if (pageType === 3) {
          userType = "supplier";
        }

        const url = `/v1/${userType}/logout`;

        const axiosInstance = getAxiosInstance(pageType);

        const response = await axiosInstance.post(
          `${process.env.REACT_APP_WEB_API_BASE_URL}${url}`
        );

        removeCookie(`${userType}Token`);

        let logUsers: CurrentActiveUserInterface[] | null;

        logUsers = (loggedUsers as CurrentActiveUserInterface[])?.filter(
          (u: any) => u?.role !== userType
        );

        saveLoggedUsers(logUsers);

        if (logUsers.length > 0) {
          if (logUsers[0].role === "buyer") {
            navigate("/buyer", { replace: true });
          } else if (logUsers[0].role === "reseller") {
            navigate("/reseller", { replace: true });
          } else {
            navigate("/supplier", { replace: true });
          }

          const saveCurrentActiveUser = storeGetUserLogin.saveCurrentActiveUser;
          saveCurrentActiveUser(logUsers[0]);

          const fetchUserHeader = useUserHeader.getState().fetchUserHeader;
          if (logUsers[0].id && logUsers[0].role) {
            fetchUserHeader(logUsers[0].id, logUsers[0].role);
          }
        } else {
          removeCookie("currentActiveUser");
          removeCookie("loggedUsers");
          window.location.href = `${process.env.REACT_APP_FRONTEND_URL}`;
        }

        return response;
      } catch (error: any) {
        toast({
          description: error?.response?.data?.message || "",
        });

        removeCookie(`buyerToken`);
        removeCookie(`resellerToken`);
        removeCookie(`supplierToken`);
        removeCookie("currentActiveUser");
        removeCookie("loggedUsers");

        window.location.href = `${process.env.REACT_APP_FRONTEND_URL}`;
      }
    };

    try {
      localStorage.removeItem("dontShowNotificationModal");

      if (currentActiveUser?.role === "buyer") {
        response = await logoutUser(1);
      } else if (currentActiveUser?.role === "reseller") {
        response = await logoutUser(2);
      } else if (currentActiveUser?.role === "supplier") {
        response = await logoutUser(3);
      }

      toast({
        title: response?.data?.message || "Logout berhasil",
        status: "success",
      });
    } catch (error: any) {
      toast({
        description: error?.response?.data?.message || "",
      });
    } finally {
      set({ isLogoutLoading: false });
    }
  },
}));
